import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { type Modification } from 'src/types/modification';

import ModificationService from '../components/pages/adminConfiguration/modificationConfig/service/modificationService';

// **** Types **** //

interface ModificationsState {
  modifications: Modification[];
}

// **** API Calls **** //

export const getModifications = createAsyncThunk('modifications/getModifications', async () => {
  return await ModificationService.getModifications();
});

// **** Setup Slice **** //

const initialState: ModificationsState = { modifications: [] };

// "Modifications Slice"
const { reducer } = createSlice({
  name: 'modificationsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getModifications.fulfilled, (state, { payload }) => {
      state.modifications = payload;
    });
  },
});

// **** Export **** //

export default reducer;
